<script>
export default {
  name: 'VisibilityObserver',
  render () {
    return null
  },
  props: {
    name: {
      type: String,
      required: true
    }
  },
  created () {
    document.addEventListener('visibilitychange', () => {
      this.$emit('change', {
        name: this.name,
        timeStamp: new Date().getTime(),
        visibilityState: document.visibilityState
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/visibility-observer/visibility-observer.vue